"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _system = _interopRequireWildcard(require("../../../utils/system"));

var _ModalContext = require("../ModalContext/ModalContext");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /**
   * The content of the modal header.
   */
  children: _propTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the components.
   */
  classes: (0, _propTypes.shape)({
    wrapper: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func]),
    close: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func])
  }),

  /**
   * If is `true` a default button will be used to close the modal.
   */
  withClose: _propTypes.bool
};
var defaultProps = {
  classes: {
    close: null,
    wrapper: null
  },
  withClose: false
};
var ModalHeader = (0, _system["default"])('div')({
  label: 'ModalHeader'
}, {
  alignItems: 'flex-start',
  display: 'flex',
  justifyContent: 'space-between'
});
var ModalHeaderWrapper = (0, _base["default"])("div", process.env.NODE_ENV === "production" ? {
  target: "e8qrrbb1"
} : {
  target: "e8qrrbb1",
  label: "ModalHeaderWrapper"
})((0, _system.classesStyles)('wrapper'));
var ModalHeaderClose = (0, _base["default"])("button", process.env.NODE_ENV === "production" ? {
  target: "e8qrrbb0"
} : {
  target: "e8qrrbb0",
  label: "ModalHeaderClose"
})("background:none;border:none;cursor:pointer;margin:0;padding:0;", (0, _system.classesStyles)('close'));
var Component = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var classes = _ref.classes,
      withClose = _ref.withClose,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["classes", "withClose", "children"]);

  var modal = (0, _ModalContext.useModal)();
  var classesProps = {
    classes: classes
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(ModalHeader, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ModalHeaderWrapper, _objectSpread(_objectSpread({}, classesProps), {}, {
      "data-modal-header-wrapper": true,
      children: children
    })), withClose && /*#__PURE__*/(0, _jsxRuntime.jsx)(ModalHeaderClose, _objectSpread(_objectSpread({}, classesProps), {}, {
      type: "button",
      onClick: modal.hide,
      "data-modal-header-close": true,
      children: "x"
    }))]
  }));
});
Component.displayName = 'ModalHeader';
Component.propTypes = propTypes;
Component.defaultProps = defaultProps;
var _default = Component;
exports["default"] = _default;

//# sourceMappingURL=ModalHeader.js.map